import React from 'react';
import { useSelector } from 'react-redux';
import { Badge, Space } from 'antd';
import { UserAvatar } from 'components/UserAvatar';
import { Container } from 'ui/Container';
import { HeaderWrapper } from './style';

const BADGE_OVERFLOW_COUNT = 999_999;

function AppHeader() {
  const {
    user: {
      username,
      role,
      fullName,
      isSuperUser,
      tribeName,
      tribeRole,
      password_old,
    },
  } = useSelector((state) => state.auth);
  const { title, count } = useSelector((state) => state.appLayout);

  return (
    <HeaderWrapper>
      <Container>
        <div className="inner">
          <Badge
            count={count}
            overflowCount={BADGE_OVERFLOW_COUNT}
            size="small"
            offset={[5, -6]}
          >
            <h3 style={{ fontWeight: 500 }}>{title}</h3>
          </Badge>

          <Space size="middle" align="center">
            <UserAvatar
              tribeRole={tribeRole}
              username={fullName || username}
              role={role}
              tribeName={tribeName}
              isSuperUser={isSuperUser}
              password_old={password_old}
            />
          </Space>
        </div>
      </Container>
    </HeaderWrapper>
  );
}

export { AppHeader };
